var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',{attrs:{"dark":"","timeout":5500,"multi-line":_vm.isMobile,"color":_vm.color},model:{value:(_vm.showToast),callback:function ($$v) {_vm.showToast=$$v},expression:"showToast"}},[_vm._v(_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }